
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 35 28","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"35","height":"28","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAcCAQAAABB/M6qAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGR4DrGwHAAAC6UlEQVQ4y52Vb2iVdRTHP/fuNp253euEsRdNZ9Mh7kVqZH9mg0JfBBGkKexFvlBWEBU4oSSJQWREGZYvCooMKluUDqyUNmRbOAXDsYkRSF6wTGeTbjf/zd10n17s3tuze++zQee8eb7nHL6cc37nnAeZUfc6KWmfD4uZmQTvMGHChGsdN/7/aXI6z3EX5FHc9+13mxGRGOFyH69SFcBL+Z7f8ugdGtnLTpropTNiOM0FPuFkAKcYYCKPhnmJHtaxiXvoCy9hlrdsnKbEjzxiTMRGb0ZDcxlnFz+RzmqKQ8yd4u+liSiVzGM16embWu/yrK50yE0BT8wzPit+q6Z9fLoWwznq2U0EKGMJPwc8bUzwMS200MB5/inV4hg11HCNP/mLO1nPZOGnGMpH1HCaI7TRz0F2AgVzE/Npe814y7R/q+ftcovVBaVG7bHbQdP+bkXx+C3ypEm3uzT7Agmb3eFxM3b5QCBuu0njRuz35Zztv6IWcoxvaCfDY6wmzg3eYhSAxbxGK8f4lTF+YYQPaGGQKKOsYTjXh0mJ0skhnqOJL6nmO0aopAKAWjrYwAAnuEg1D7KGHQwCK5jgVL5b2bSeMukc673sG5YHCljlqPttCFgqJrfIDvcVr+YXviLu99MpzVxi2vaQmfoxOEe5j37XiT9Yl9/mmDjg7hCSuxwPvmBuGW5SBTzKWjqo4ygpkmyhgQO0cW+JwWylj1QAZ/ne9ENxn2cdcMxuE3Z620uO2eN1m4uyGXJzqbO1ypTLzFhruRudK7aoN7xf3OOuApKVXrWy9PXr8zMz3h1wPuIKcZbH3VpA87XvTrVEfI84AIto5gpRDhJcszIeZiEHuBawldPKYS7nj1k7xDjL/Ow2z6aBPUXNTBZZ5gMpzmXRH4WrWetFX5zxsJfZbVd2BEP+DA+VfJWp+rpnrCq0Fga94Ii105A84VWbiu3FZ+tzFvAkt0tewzqO8gxflfAUMc9x2HB5u3SW/wKSShwAxGQEUwAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    